const state = {
  // 0: start 10:数据导入完成 20:设置参数完成 30: 分配客户完成 40:路线求解完成
  solution_status: 0
}

const getters = {
  solutionStatus: state => state.solution_status
}

const actions = {
  setSolutionStatus ({ commit }, data) {
    commit('changeSolutionStatus', data)
  }
}

const mutations = {
  changeSolutionStatus (state, data) {
    state.solution_status = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/process.js